// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-487d671c] .i-text p {
  margin: 0;
}
.message-content[data-v-487d671c] {
  word-break: break-word;
}
.message-container[data-v-487d671c] {
  margin-top: -2px !important;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/conversations/components/message/Message.vue","webpack://./Message.vue"],"names":[],"mappings":"AAEA;EACE,SAAA;ACDF;ADIA;EACE,sBAAA;ACDF;ADIA;EACE,2BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n:deep(.i-text p) {\n  margin: 0;\n}\n\n.message-content {\n  word-break: break-word;\n}\n\n.message-container {\n  margin-top: -2px !important;\n}\n",":deep(.i-text p) {\n  margin: 0;\n}\n\n.message-content {\n  word-break: break-word;\n}\n\n.message-container {\n  margin-top: -2px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
